var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 18.4,
    viewBox: "0 0 23 18.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wallet-332327",
    transform: "translate(-116.668 -93.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M138.518,93.332h-20.7a1.087,1.087,0,0,0-1.15,1.15v16.1a1.086,1.086,0,0,0,1.15,1.15h20.7a1.086,1.086,0,0,0,1.15-1.15v-5.75h-8.05a2.3,2.3,0,0,1,0-4.6h8.05v-5.75a1.087,1.087,0,0,0-1.15-1.15Z",
    transform: "translate(0 0)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M398.966,257.818a1.15,1.15,0,1,1-1.15-1.15,1.15,1.15,0,0,1,1.15,1.15",
    transform: "translate(-266.198 -155.286)",
    fill: "#a0a0a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f5dba3f35a57341f1662f25405ed7acd.svg";
export { ForwardRef as ReactComponent };